import GenlLogo from '../assets/genl-logo.svg';
import AgentKitLogo from '../assets/agentkit-logo.svg';
import VoxLogo from '../assets/vox-logo.svg';

// export const BASE_URL = "https://lead-gen-backend.onrender.com/api/v1"
export const BASE_URL = "http://localhost:3333/api/v1"

export const SERVICES_OFFERED = [
    {
        // TODO(asset): replace with /agent-icon.svg
        imgSrc: "/placeholder-logo.png",
        altText: "AI agent icon",
        firstText: "AI Agent Development",
        secondText: "We design and deploy autonomous AI agents that reason, plan, and act - from single-purpose task agents to complex multi-agent pipelines that run your business workflows 24/7.",
        images: [
            { src: "/claude.png", caption: "Claude API" },
            { src: "/openai.png", caption: "OpenAI" },
            { src: "/langchain.png", caption: "LangChain" },
            { src: "/langgraph.png", caption: "LangGraph" },
            { src: "/autogen.png", caption: "AutoGen" },
            { src: "/crewai.png", caption: "CrewAI" },
        ]
    },
    {
        // TODO(asset): replace with /llm-icon.svg
        imgSrc: "/placeholder-logo.png",
        altText: "LLM and RAG icon",
        firstText: "LLM Integration & RAG",
        secondText: "We embed large language models into your existing products and build retrieval-augmented generation systems that give your AI deep, accurate knowledge of your business data.",
        images: [
            { src: "/openai.png", caption: "OpenAI" },
            { src: "/claude.png", caption: "Claude API" },
            { src: "/pinecone.png", caption: "Pinecone" },
            { src: "/weaviate.png", caption: "Weaviate" },
            { src: "/langchain.png", caption: "LangChain" },
        ]
    },
    {
        // TODO(asset): replace with /automation-icon.svg
        imgSrc: "/placeholder-logo.png",
        altText: "Automation pipeline icon",
        firstText: "Automation & Agentic Workflows",
        secondText: "We build intelligent automation pipelines using n8n, Make, and Zapier AI - connecting your tools, triggering on events, and handling complex branching logic without human intervention.",
        images: [
            { src: "/n8n.png", caption: "n8n" },
            { src: "/make.png", caption: "Make" },
            { src: "/zapier.png", caption: "Zapier" },
        ]
    },
    {
        // TODO(asset): replace with /voice-icon.svg
        imgSrc: "/placeholder-logo.png",
        altText: "Voice AI icon",
        firstText: "Voice AI & Conversational Interfaces",
        secondText: "We build voice-first agents and chat interfaces powered by real-time speech models - for customer support bots, internal assistants, IVR replacement, and product copilots.",
        images: [
            { src: "/elevenlabs.png", caption: "ElevenLabs" },
            { src: "/openai.png", caption: "OpenAI" },
            { src: "/twilio.png", caption: "Twilio" },
        ]
    },
]

// Rollback safety net (LLD §13.2). Not imported by any component.
// Preserves the pre-transformation 4-entry services array verbatim,
// including the './graphics-icon.svg' typo on the Graphic Design entry.
export const LEGACY_SERVICES = [
    {
        imgSrc: "/web-icon.svg",
        altText: "Web Icon",
        firstText: "Web Development",
        secondText: "Web development is the work involved in developing a website for the Internet or an intranet.",
        images: [
            { src: '/html.png', caption: 'HTML' },
            { src: '/css.png', caption: 'CSS' },
            { src: '/react.png', caption: 'React Js' },
            { src: '/nodejs.png', caption: 'Node.js' },
            { src: '/php.png', caption: 'PHP' },
            { src: '/fastapi.png', caption: 'Fast Api' },
        ]
    },
    {
        imgSrc: "/ui-icon.svg",
        altText: "UI Icon",
        firstText: "UI/UX Design",
        secondText: "UX design refers to the term “user experience design” while UI stands for “user interface design”.",
        images: [
            { src: '/figma.png', caption: 'Figma' },
            { src: '/adobexd.png', caption: 'Adobe XD' }
        ]
    },
    {
        imgSrc: "/app-icon.svg",
        altText: "App Icon",
        firstText: "App Development",
        secondText: "App development is the process by which a mobile app is developed for one or more mobile devices, which can include personal digital assistants, etc.",
        images: [
            { src: '/android.png', caption: 'Android' },
            { src: '/react.png', caption: 'React Native' },
            { src: '/flutter.png', caption: 'Flutter' },
            { src: '/swift.png', caption: 'Swift' }
        ]
    },
    {
        imgSrc: "./graphics-icon.svg",
        altText: "Graphics Icon",
        firstText: "Graphic Design",
        secondText: "Graphic design is defined as the art and practice of planning and projecting ideas and experiences with visual and textual content.",
        images: [
            { src: '/photoshop.png', caption: 'Photoshop' },
            { src: '/illustrator.png', caption: 'Illustrator' },
            { src: '/aftereffects.png', caption: 'After Effects' },
            { src: '/canva.png', caption: 'Canva' }
        ]
    }
]

export const PRODUCTS = [
    {
        productName: "Lead Generation Platform",
        productTitle: "GenL",
        productDescription: "Boost your business with a lead-providing website that connects you with ready-to-convert customers. Our platform delivers high-quality leads through targeted strategies and optimized user experiences, ensuring you get the right prospects to drive your sales and growth.",
        productUrl: "https://genl.tryouts.tech/",
        productLogo: GenlLogo,
    },
]
